// Generated from src/img/svg/s6.svg

export const S6 = (props) => {
  return (
    <svg viewBox="0 0 26 13" {...props}>
      <rect fill="#00965f" height="13" rx="6.5" width="25" x=".5" />
      <g
        aria-label="S6"
        style={{
          fill: "#fff",
          fontFamily: 'HelveticaNeue-Bold,"Helvetica Neue",sans-serif',
          fontSize: "10px",
          fontWeight: "700",
          transform: "translate(.5px,0)",
        }}
      >
        <path d="M6.715 7.63h1.52q0 .67.48 1.02.41.3 1.1.3.54 0 .9-.17.49-.23.49-.72 0-.61-1.1-.92-1.9-.54-2.05-.62-1.1-.53-1.1-1.67 0-1.03.85-1.63.76-.53 1.82-.53 1.23 0 1.99.53.87.61.87 1.77h-1.52q-.06-1.08-1.41-1.08-.43 0-.73.18-.35.22-.35.63 0 .39.39.57.3.14 1.74.51.84.21 1.25.48.87.56.87 1.6 0 1.02-.76 1.64-.8.65-2.21.65-1.29 0-2.12-.61-.93-.69-.92-1.93M18.195 4.8h-1.35q-.07-.37-.33-.62-.25-.25-.61-.25-.68 0-1.04.77-.26.56-.3 1.36l.02.02q.55-.78 1.58-.78.97 0 1.61.72.54.61.54 1.56 0 1.09-.69 1.83-.68.73-1.76.73-1.46 0-2.14-1.15-.55-.92-.55-2.47 0-1.47.63-2.47.74-1.19 2.12-1.19.92 0 1.53.52.62.51.74 1.42m-2.37 1.57q-.54 0-.84.38-.29.37-.29.92 0 .52.3.89.32.41.83.41.48 0 .79-.4.28-.37.28-.88 0-.54-.26-.91-.29-.41-.81-.41" />
      </g>
    </svg>
  );
};
